export function MonitoringCtrl ($scope) {
  $scope.setSomething = true
}



// WEBPACK FOOTER //
// ./app/scripts/controllers/monitoring.js